//hooks
import useTranslation from 'next-translate/useTranslation';
import useUser from '@/utils/hooks/swr/useUser';
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';
import useFormatNumber from '@/hooks/format/useFormatNumber';

//components
import { BillingActions } from '@/components/pages/settings/subscription-invoices/UserBilling/BillingActions';

export function Billing() {
    const { subscription } = useSubscription();
    const { t } = useTranslation('settings');
    const { user } = useUser({
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    const numberFormat = user?.settings?.numbers_format;
    const { formatPriceCurrencySymbol } = useFormatNumber(numberFormat);

    if (!subscription.product_key || subscription.product_key === 'trial') {
        return (
            <p data-testid="new-pricing-no-subscription">
                {t('subscription_invoices_page.no_billing')}
            </p>
        );
    }

    return (
        <div className="flex flex-col space-y-8" data-testid="subscription-details">
            <div className="flex items-center justify-between gap-2">
                <div className="text-sm">
                    <span>
                        {t(
                            `subscription_invoices_page.new_pricing.plans.${subscription.product_key}`
                        )}
                    </span>
                    &nbsp;
                    <span className="font-GMedium italic text-icoGray-500 dark:text-icoDarkMode-wolf">
                        {`(${t(
                            `subscription_invoices_page.new_pricing.billed_${subscription.frequency}`
                        )})`}
                    </span>
                </div>
                <span className="block min-w-max text-icoBlue">
                    {formatPriceCurrencySymbol(subscription.total, subscription.currency)}
                </span>
            </div>
            <BillingActions />
        </div>
    );
}
